export enum Roles {
  ADMIN,
  NURSEADMIN,
  NURSE,
  UNKNOWN,
}

export enum Features {
  MANAGE_MARIS = "manageMaris",
  MANAGE_RESIDENTS = "manageClients",
  MANAGE_PERIPHERALS = "managePeripherals",
}

export const ROLE_DEFAULT_PATH: any = {
  ADMIN: "/manage-sensors",
  NURSEADMIN: "/residents-overview",
  NURSE: "/residents-overview",
};

export enum ROUTES {
  INITIAL_CONFIGURATION = "/manage-maris",
  LOGIN = "/login",
}
